import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100/60">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950">动画资讯速递</h2>
          <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-xl mx-auto">
            漫画相关的动画化、剧场版与周边资讯，让你不错过每一条精彩动态
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative overflow-hidden aspect-video">
                <img
                  src={item.thumbnail}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-950/60 text-background-50 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-lg md:text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}